import { isVqaOnlyOrg, withoutVqqRights } from "./vqaOnlyOrg";

/**
 * Resolves sponsor rights/sub-roles for route guards.
 * Sidebar and nav use Identity `/SponsorUsers/Me`; ProtectedRoute must match that source,
 * not only Clerk publicMetadata (which can lag or omit rights).
 */

function normalizeStringList(values) {
  if (!Array.isArray(values)) return [];
  return values
    .map((item) =>
      typeof item === "string"
        ? item
        : item?.rights ?? item?.sub_role ?? item?.subrole
    )
    .filter(Boolean);
}

/**
 * @param {{
 *   clerkMetadata?: Record<string, unknown>;
 *   sponsorProfile?: Record<string, unknown> | null;
 *   reduxRights?: string[];
 * }} sources
 */
export function resolveSponsorAccess(sources) {
  const access = resolveGrantedSponsorAccess(sources);
  return {
    ...access,
    rights: withoutVqqRights(access.rights, isVqaOnlyOrg(sources.sponsorProfile)),
  };
}

function resolveGrantedSponsorAccess(sources) {
  const clerkMetadata = sources.clerkMetadata || {};
  const profile = sources.sponsorProfile;
  const profileRights = normalizeStringList(profile?.rights);
  const profileSubRoles = normalizeStringList(profile?.sub_role);
  const reduxRights = normalizeStringList(sources.reduxRights);
  const clerkRights = normalizeStringList(clerkMetadata.rights);
  const clerkSubRoles = normalizeStringList(clerkMetadata.sub_role);

  if (profileRights.length > 0) {
    return {
      rights: profileRights,
      subRoles: profileSubRoles.length > 0 ? profileSubRoles : clerkSubRoles,
      role: profile?.role ?? clerkMetadata.role,
    };
  }

  if (reduxRights.length > 0) {
    return {
      rights: reduxRights,
      subRoles: clerkSubRoles,
      role: clerkMetadata.role,
    };
  }

  return {
    rights: clerkRights,
    subRoles: clerkSubRoles,
    role: clerkMetadata.role,
  };
}

/** Prefer Redux/API profile org flag; fall back to legacy Clerk metadata key. */
export function isTrialExperienceOrgEnabled(loggedInUser, sponsorProfile, clerkMetadata) {
  const fromProfile =
    sponsorProfile?.has_trial_experience ?? loggedInUser?.userDetails?.has_trial_experience;
  if (fromProfile === true || fromProfile === "true") return true;
  const legacy = clerkMetadata?.trial_experience_enabled;
  return legacy === true || legacy === "true";
}
